module.exports = __webpack_public_path__ + "media/assets/8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/assets/8.svg
// module id = 20
// module chunks = 0